const names = new Intl.Collator("fr", { sensitivity: "base", numeric: true });
const labels = {
  SPOUSE: "Mariage", PARTNER: "Couple", SIBLING: "Fratrie", OTHER_FAMILY: "Autre lien familial",
  COLLABORATOR: "Collaboration (V1)", BUSINESS_PARTNER: "Association (V1)", FRIEND: "Amitié (V1)",
  CO_FOUNDED_WITH: "Cofondation", CO_LED_WITH: "Codirection", CO_AUTHORED_WITH: "Coécriture",
  COLLABORATED_CLOSELY_WITH: "Collaboration étroite",
};

// One row per person, with all distinct relations. Include both ends of directed
// edges and all collected links, independently of visual filters on the graph.
export function personConnections(graph, selected) {
  if (!graph.hasNode(selected)) return [];
  const people = new Map();
  for (const edge of graph.edges(selected)) {
    const [source, target] = graph.extremities(edge);
    const id = source === selected ? target : source;
    if (id === selected) continue;
    const data = graph.getEdgeAttributes(edge);
    let relation = data.relationType === "PARENT_OF" ? (source === selected ? "Enfant" : "Parent")
      : data.relationType === "MENTOR_OF" ? (source === selected ? "Personne accompagnée" : "Mentor")
      : labels[data.relationType] || "Relation documentée";
    if (data.temporalStatus === "PAST") relation += " (passé)";
    if (!people.has(id)) people.set(id, { id, name: graph.getNodeAttribute(id, "label") || id, relations: new Set(), edges: [] });
    people.get(id).relations.add(relation);
    people.get(id).edges.push({ id: edge, relation });
  }
  return [...people.values()].map(person => ({ ...person, relations: [...person.relations].sort(names.compare), edges: person.edges.sort((a, b) => names.compare(a.relation, b.relation) || names.compare(a.id, b.id)) }))
    .sort((a, b) => names.compare(a.name, b.name) || names.compare(a.id, b.id));
}
